import { HcaId, HcaLibraryResponse, HcaSectionResponse, HcaStepResponse } from '@business/entities/hca_library';
import { Endpoint } from '../endpoint';

export function fetchHcaLibraries() {
  return Endpoint.get<HcaLibraryResponse[]>(`@makh/hca-library/volumes`);
}

export function fetchHcaSteps() {
  return Endpoint.get<HcaLibraryResponse[]>(`@makh/hca-step/hca-step`);
}

export function fetchHcaLibrary(id: HcaId) {
  return Endpoint.get<HcaLibraryResponse>(`@makh/hca-library/hca-library/${id}`);
}

export function fetchParentSections(id: HcaId) {
  return Endpoint.get<HcaSectionResponse>(`@makh/hca-library/parent-sections/${id}`);
}

export function createVolume(volume: Partial<HcaLibraryResponse>) {
  return Endpoint.post<HcaLibraryResponse>(`@makh/hca-library`, { data: { ...volume } });
}

export function updateVolume(id: HcaId, data: Partial<HcaLibraryResponse>) {
  return Endpoint.patch<HcaLibraryResponse>(`@makh/hca-library/${id}`, { data });
}

export function orderLessons(id: HcaId, items: Partial<HcaLibraryResponse>) {
  return Endpoint.post<HcaLibraryResponse>(`@makh/hca-library/order-lessons/${id}`, { data: { items } });
}

export function searchArticles(search: string[]) {
  return Endpoint.post<HcaStepResponse[]>(`@makh/hca-library/search-articles`, { data: { search } });
}

export function deleteVolume(id: HcaId) {
  return Endpoint.delete<void>(`@makh/hca-library/${id}`);
}
